import React from 'react'
import t from '../Language/language'
import * as languageSettings from '../Language/languageSettings'
import SettingService from '../Common/SettingService'
import NavigationServices from '../Common/NavigationServices'
import AuthenticationService from '../Security/AuthenticationService'
import { Config } from '../../Config'
import { CommonConstants } from '../../Constants'
import Api from '../../Api'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { getUserAccountDetails } from '../../actions/userAccounts'
const BlackEye = require('../../images/black_eye2.png')

class AdminSubHeader extends React.Component {
  constructor (props) {
    super(props)
    this.settings = new SettingService()
    this.navigation = new NavigationServices()
    this.state = {
      language: languageSettings.getCurrentLanguage(),
      CompanyType: 'Franchise',
      isOwner: 0,
      userUid: null,
      user: ''
    }
    this.api = new Api()
    this.authService = new AuthenticationService(Config.authBaseUrl)
    this.state.user = this.authService.getUserEmail()
    this.state.userUid = this.authService.getUUID()
  }
  componentWillMount () {
    this.checkUserUUID()
  }
  // Checking the useruid in the url query param.
  checkUserUUID () {
    if (window.location) {
      const params = new URLSearchParams(window.location.search)
      if (params) {
        if (!params.get('uuid')) {
          this.authService.clearViewingAsOwner()
        }
      }
    }
  }
  // Handling viewing as user/owner.
  handleViewingAs () {
    if (this.authService.getSelectedMenu() === 'accounts') {
      // Fetching the values from local storage.
      let lsData = (JSON.parse(this.authService.getViewingAsOwner('ViewingAsOwner'))) || null
      if (lsData) {
        this.setState({ user: lsData.userEmail })
        this.setState({ isOwner: lsData.isOwner, userEmail: lsData.userEmail, userUid: lsData.userUid })
      } else {
        // setting the values to local storage.
        this.setState({ isOwner: 1 })
        let ViewingAsOwner = {
          isOwner: 1,
          userEmail: this.authService.getUserEmail(),
          userUid: this.authService.getUUID(),
          CompanyType: this.state.CompanyType || 'Franchise'
        }
        // Making function call to set the values to local storage.
        this.authService.setViewingAsOwner(ViewingAsOwner)
      }
    }
  }
  componentDidMount () {
    if (this.authService.getUUID()) {
      // Fetching the user details.
      let uuid = this.authService.getUUID()
      let url = Config.apiBaseUrl + CommonConstants.apiUrls.getUser + '?uuId=' + uuid
      this.api.getData(url, data => {
        let userObject = data.data
        this.authService.setUserEmail(userObject.userEmail)
        this.setState({ user: this.authService.getUserEmail() })
        this.handleViewingAs()
      })
      // Fetching the account details.
      this.props.getUserAccountDetails(this.state.userUid, function () {
        let accountData = this.props.userAccounts[0]
        this.setState({ CompanyType: accountData.Company_Type })
      })
    }
  }
  // Handling navigation.
  navigatation () {
    if (this.authService.getSelectedMenu() === 'accounts') {
      if (this.state.isOwner === 1) {
        let userUid = null
        let lsData = (JSON.parse(this.authService.getViewingAsOwner('ViewingAsOwner'))) || null
        if (lsData) {
          userUid = lsData.userUid
        } else {
          userUid = this.state.userUid
        }
        window.location.href = '/admin/account?' + 'type=' + this.state.CompanyType + '&uuid=' + userUid
      } else {
        window.location.href = '/admin/account?' + 'type=' + this.state.CompanyType + '&uuid=' + this.state.userUid
      }
    } else {
      window.location.href = '/settings/users/user?uuid=' + this.state.userUid
    }
  }
  // Handling submenu.
  renderMenuItem (menu, display) {
    let active = (window.location.pathname ? (window.location.pathname.toLowerCase().indexOf(menu) !== -1 ? 'active_tab_sub' : '') : '')
    return (<li>
      <a className={'headerMenu ' + active} href={this.navigation.getSubMenuUrl(menu)} >{display}</a>
    </li>)
  }
  // Main render method.
  render () {
    const { language } = this.state
    if (this.settings.canShowAdminSubHeader()) {
      return (
        <div>
          <div className='subMenu menuBar '>
            <div className='subHeaderSection'>
              <ul className='subHeaders'>
                {this.renderMenuItem('stores', t[language].stores)}
                {this.renderMenuItem('users', t[language].users)}
                {this.renderMenuItem('roles', t[language].roles)}
                {this.renderMenuItem('dashboard', t[language].subNavbarDashboard)}
                {this.renderMenuItem('reports', t[language].navbarReports)}
                {this.renderMenuItem('devicehistory', t[language].subNavbarDeviceSettingsHistory)}
              </ul>
            </div>
          </div>
          <div className='viewingAsSection'>
            <div className='viewing_as'>
              <span><img className='blackEye' src={BlackEye} width='15' height='17' alt='Viewing as' />
                {this.state.isOwner === 1 ? t[language].currentlyviewingasUserAccountOwner : t[language].currentlyviewingasUser} <a onClick={this.navigatation.bind(this)}><span className='green_id'>{this.state.user}</span></a>
              </span>
            </div>
          </div>
        </div>
      )
    } else {
      return ''
    }
  }
}
// setting the props to state.
function mapStateToProps (state) {
  return {
    headers: state.headers
  }
}
// Binding the actions.
function matchDispatchToProps (dispatch) {
  return bindActionCreators(
    {
      getUserAccountDetails
    }, dispatch
  )
}
export default connect(mapStateToProps, matchDispatchToProps)(AdminSubHeader)



// WEBPACK FOOTER //
// ./src/components/Header/adminSubHeader.js